import _extends from '@babel/runtime/helpers/extends';
import React__default from 'react';
import { B as BoxStyled } from './Box.styles-Ber_lsO-.js';
import { u as useSurface, S as SurfaceContext } from '../SurfaceProvider/SurfaceProvider-qDGZSFCj.js';
import { T as TaktIdProvider } from '../TaktIdContext/TaktIdContext-C6vdL-6Z.js';
import { c as createStormTaktId } from '../TaktIdContext/TaktIdContext.utils-B0CzqlN8.js';

const Box = ({
  children,
  flex,
  basis,
  grow,
  shrink,
  alignSelf,
  justifySelf,
  placeSelf,
  area,
  row,
  column,
  columnStart,
  columnEnd,
  rowStart,
  rowEnd,
  renderAs,
  padding = 'large',
  paddingBlockStart,
  paddingBlockEnd,
  paddingInlineStart,
  paddingInlineEnd,
  bgColor,
  square = false,
  taktId,
  taktValue,
  ...rest
}) => {
  const {
    isInverted: hasInvertedSurfaceAncestor
  } = useSurface();
  let isInverted = hasInvertedSurfaceAncestor;
  if (bgColor !== undefined) {
    isInverted = bgColor === 'inverted';
  }
  return /*#__PURE__*/React__default.createElement(TaktIdProvider, {
    taktId: taktId,
    taktValue: taktValue,
    fallbackId: createStormTaktId('box')
  }, /*#__PURE__*/React__default.createElement(SurfaceContext.Provider, {
    value: {
      isInverted
    }
  }, /*#__PURE__*/React__default.createElement(BoxStyled, _extends({}, rest, {
    $bgColor: bgColor,
    as: renderAs !== null && renderAs !== void 0 ? renderAs : 'div',
    $flex: flex,
    $basis: basis,
    $grow: grow,
    $shrink: shrink,
    $alignSelf: alignSelf,
    $justifySelf: justifySelf,
    $placeSelf: placeSelf,
    $area: area,
    $row: row,
    $column: column,
    $columnStart: columnStart,
    $columnEnd: columnEnd,
    $rowStart: rowStart,
    $rowEnd: rowEnd,
    $padding: padding,
    $paddingBlockStart: paddingBlockStart,
    $paddingBlockEnd: paddingBlockEnd,
    $paddingInlineStart: paddingInlineStart,
    $paddingInlineEnd: paddingInlineEnd,
    $square: square
  }), children)));
};

export { Box as B };
//# sourceMappingURL=Box-BPZ8tqkL.js.map
